import {ArrowLeft, Compass} from '../../../components/PhosphorIcons'
import {Link} from 'react-router-dom'

const Error404 = () => (
  <main className='error-page'>
    <div className='error-card'>
      <span className='error-card__icon'>
        <Compass aria-hidden='true' size={30} weight='duotone' />
      </span>
      <span className='error-card__code'>404</span>
      <h1>Такой страницы нет</h1>
      <p>Возможно, ссылка устарела или адрес был введён с ошибкой.</p>
      <Link className='btn btn-primary' to='/dashboard'>
        <ArrowLeft aria-hidden='true' size={16} weight='bold' />
        Вернуться к обзору
      </Link>
    </div>
  </main>
)

export {Error404}
